import React from 'react';
import TripSummaryPanel from './TripSummaryPanel';
import QualityMeter from './QualityMeter';
import SavedIndicator from './SavedIndicator';

const QuestionnaireV2Layout = ({
  children,
  formData,
  qualityScore,
  isSaving,
  lastSaved,
  sidebarContent,
}) => {
  return (
    <div className="questionnaire-v2-layout flex gap-8 max-w-[1400px] mx-auto p-8 min-h-screen max-lg:flex-col max-lg:p-4">
      <div className="questionnaire-v2-main flex-1 min-w-0">
        <div className="questionnaire-v2-content rounded-xl p-8 max-sm:p-6">
          {children}
        </div>
      </div>
      <div className="questionnaire-v2-sidebar w-80 flex-shrink-0 max-lg:w-full">
        <div className="sidebar-sticky flex flex-col gap-6 max-lg:static">
          <div className="summary-panel">
            <div className="summary-panel__status">
              <div className="summary-panel__badges">
                <div className="summary-panel__pill">
                  <SavedIndicator isSaving={isSaving} lastSaved={lastSaved} />
                </div>
                <div className="summary-panel__pill">
                  <QualityMeter score={qualityScore} compact />
                </div>
              </div>
            </div>
            <div className="summary-panel__preview">
              <TripSummaryPanel formData={formData} />
            </div>
            {sidebarContent && (
              <div className="summary-panel__tip-layer">
                {sidebarContent}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireV2Layout;
